import { ReactNode, useState } from 'react';
import { ThemedAlert } from './ThemedAlert';
import { AlertContext } from './AlertContext';
import { AlertOptions, AlertState } from './types';

interface AlertProviderProps {
    children: ReactNode;
}

export const AlertProvider = ({ children }: AlertProviderProps) => {
    const [alertState, setAlertState] = useState<AlertState>({
        isOpen: false,
        options: null
    });

    const showAlert = (options: AlertOptions) => {
        setAlertState({
            isOpen: true,
            options
        });
    };

    const hideAlert = () => {
        setAlertState({
            isOpen: false,
            options: alertState.options
        });

        if (alertState.options?.onClose) {
            alertState.options.onClose();
        }
    };

    const value = {
        hideAlert,
        showAlert,
        alertState
    };

    return (
        <AlertContext.Provider value={value}>
            {children}
            <ThemedAlert
                onClose={hideAlert}
                open={alertState.isOpen}
                options={alertState.options!}
            />
        </AlertContext.Provider>
    );
};